export interface TicketScanSelection {
  wo_order_id: number;
  wo_order_d_id: number;
  wo_plan_id: number | null;
}

export interface TicketScanProcess {
  wo_plan_id: number;
  wo_order_id: number;
  urutan: number;
  nama_proses: string;
  qty_target: number;
  qty_hasil: number;
  tgl_awal?: string | null;
  tgl_selesai?: string | null;
  status: 'belum_mulai' | 'proses' | 'selesai' | string;
}

export interface ScannedProcessTicket {
  id: number;
  wo_order_id: number;
  kode_work_order?: string;
  qty: number;
  satuan?: string;
  nama_product?: string;
  kode_product?: string;
  scan_type: 'process_ticket' | 'ticket';
  qr_value?: string;
  selection: TicketScanSelection;
  process?: TicketScanProcess | null;
}

export const validateScannedTicket = (ticket?: ScannedProcessTicket | null) => {
  if (!ticket?.selection?.wo_order_id) return 'Work Order dari hasil scan tidak tersedia.';
  if (Number(ticket.qty) <= 0) return 'Qty tiket harus lebih dari 0.';
  if (ticket.scan_type === 'process_ticket' && (!ticket.selection.wo_plan_id || !ticket.process)) {
    return 'Data proses dari tiket tidak lengkap.';
  }
  return '';
};

export const findOrderByScan = <T extends { id: number | string }>(orders: T[], woOrderId: number) =>
  orders.find(order => String(order.id) === String(woOrderId)) || null;

export const findPlanByScan = <T extends { id?: number | string; wo_plan_id?: number | string }>(plans: T[], woPlanId: number) =>
  plans.find(plan => String(plan.wo_plan_id ?? plan.id) === String(woPlanId)) || null;

export const isDuplicateScan = (code: string, resolving: boolean, lastCode?: string) =>
  resolving || Boolean(lastCode && code.trim() === lastCode.trim());
